/**
 * @description Утилита для создания элемента с ошибкой валидации
 * @param {*} message Сообщение об ошибке, которое будет отображаться в элементе
 * @param {boolean} noInverse Добавляет no-inverse стиль для тёмного фона
 * @returns {HTMLElement} Элемент с сообщением об ошибке
 */
export function createErrorHintElement(message, noInverse = false) {
  const errorElement = document.createElement('div')
  errorElement.classList.add('hint-text', 'hint-text--error')
  if (noInverse) {
    errorElement.classList.add('hint-text--no-inverse')
  }
  errorElement.setAttribute('role', 'alert')
  errorElement.setAttribute('aria-live', 'assertive')
  errorElement.append(
    createHintIcon({
      stroke: 'currentColor',
      strokeWidth: '1.2',
      d: 'M12 15.526v1.79m0-8.053v5.369M12 3 3 20h18z'
    }),
    document.createTextNode(message)
  )
  return errorElement
}

/**
 * @description Утилита для создания элемента с подсказкой
 * @param {*} message Сообщение, которое будет отображаться в элементе
 * @returns {HTMLElement} Элемент с сообщением
 */
export function createHintElement(message, noInverse = false) {
  const hintElement = document.createElement('div')
  hintElement.classList.add('hint-text')

  if (noInverse) {
    hintElement.classList.add('hint-text--no-inverse')
  }

  hintElement.append(
    createHintIcon({
      stroke: '#202126',
      strokeLinecap: 'square',
      strokeLinejoin: 'round',
      strokeWidth: '1.5',
      d: 'M12 8v4m0 4h.01M3 12a9 9 0 1 0 18.001 0A9 9 0 0 0 3 12Z'
    }),
    document.createTextNode(message)
  )
  return hintElement
}

function createHintIcon({
  stroke,
  strokeWidth,
  d,
  strokeLinecap,
  strokeLinejoin
}) {
  const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
  svg.setAttribute('width', '24')
  svg.setAttribute('height', '24')
  svg.setAttribute('fill', 'none')
  svg.setAttribute('viewBox', '0 0 24 24')

  const path = document.createElementNS('http://www.w3.org/2000/svg', 'path')
  path.setAttribute('stroke', stroke)
  path.setAttribute('stroke-width', strokeWidth)
  path.setAttribute('d', d)
  if (strokeLinecap) path.setAttribute('stroke-linecap', strokeLinecap)
  if (strokeLinejoin) path.setAttribute('stroke-linejoin', strokeLinejoin)

  svg.appendChild(path)

  return svg
}

export function createFilterBtn(
  text,
  gray = false,
  resetable = false,
  resetAttrs = {}
) {
  const filterBtn = document.createElement('div')
  filterBtn.classList.add('filter-btn')
  if (gray) filterBtn.classList.add('filter-btn--gray')
  if (resetable) filterBtn.classList.add('filter-btn--reset')

  const btn = document.createElement('button')
  btn.classList.add('filter-btn__btn')
  btn.type = 'button'
  btn.textContent = text
  filterBtn.appendChild(btn)

  if (resetable) {
    const resetBtn = document.createElement('button')
    resetBtn.classList.add(
      'filter-btn__reset',
      'btn',
      'btn--xs',
      'btn--close',
      'btn--white',
      'btn--no-inverse'
    )
    resetBtn.type = 'button'
    resetBtn.innerHTML =
      '<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" data-icon="cross"><use href="#icon-cross"></use></svg>'
    Object.entries(resetAttrs).forEach(([key, value]) => {
      resetBtn.setAttribute(key, value)
    })
    filterBtn.appendChild(resetBtn)
  }
  return filterBtn
}

/**
 * @description Атрибуты элемента как объект `{ имя: значение }` — тот же вид, в котором
 * приходят строки данных каталога (ClubsController#catalog_data).
 * @param {Element} element
 * @returns {Object.<string, string>}
 */
export function attributeMap(element) {
  return Object.fromEntries(
    Array.from(element.attributes, (attribute) => [
      attribute.name,
      attribute.value
    ])
  )
}
